import { CONVERGENCE_STRATEGY_LABELS, RENDER_MODE_LABELS } from "@storyline/shared";
import { Handle, type NodeProps, Position } from "@xyflow/react";
import Pill from "@/src/common/components/pill";
import type { StoryFlowNodeItem, StoryNodeData } from "@/src/stories/utils/graph-view";

const OUTCOME_LABEL: Record<StoryNodeData["outcome"], string> = {
	decision: "Décision",
	direct: "Enchaînement",
	ending: "Fin statique",
	terminal: "Terminal (règles)",
};

const StoryNode: React.FC<NodeProps<StoryFlowNodeItem>> = ({ data: nodeData, selected }) => {
	const uniqueModes = [...new Set(nodeData.renderModes)];
	return (
		<div
			className={`w-60 overflow-hidden rounded-xl border bg-surface p-3 shadow-lg ${selected ? "border-accent-lav" : "border-border-soft"}`}
		>
			<Handle type="target" position={Position.Top} />
			<div className="flex items-center justify-between gap-2">
				<span className="truncate font-semibold text-foreground text-sm">{nodeData.node.title}</span>
				<span className="text-muted text-xs">#{nodeData.node.orderIndex + 1}</span>
			</div>
			<div className="mt-2 flex flex-wrap gap-1">
				{nodeData.isEntry ? <Pill tone="accent">Entrée</Pill> : null}
				{nodeData.node.convergenceStrategy ? (
					<Pill tone="warning">⇉ {CONVERGENCE_STRATEGY_LABELS[nodeData.node.convergenceStrategy]}</Pill>
				) : null}
				{nodeData.issueCount > 0 ? <Pill tone="danger">⚠ {nodeData.issueCount}</Pill> : null}
			</div>
			<p className="mt-2 text-muted text-xs">
				{nodeData.node.shots.length} plan(s) · {OUTCOME_LABEL[nodeData.outcome]}
				{nodeData.endingName ? ` → ${nodeData.endingName}` : ""}
			</p>
			{uniqueModes.length > 0 ? (
				<div className="mt-1 flex flex-wrap gap-1">
					{uniqueModes.map((mode) => (
						<span key={mode} className="rounded-full border border-border-soft px-2 py-0.5 text-muted text-xs">
							{RENDER_MODE_LABELS[mode]}
						</span>
					))}
				</div>
			) : null}
			<Handle type="source" position={Position.Bottom} />
		</div>
	);
};

export default StoryNode;
